import axios from 'axios';
import { createAuthenticatedApi } from './auth-utils';

const api = createAuthenticatedApi(import.meta.env.VITE_API_URL);

export const enrichmentApi = createAuthenticatedApi(import.meta.env.VITE_API_URL);

export const publicApi = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
})

export default api;
